import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";

export const getMedicalUserIdByEmail = (email: string, experts: CalendlyExpert[]) => {
    return experts.find(e => e.email === email)?.id || "";
}